export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "%0 z %1": "",
        "%0 znaków": "",
        "<Brak nazwy>": "",
        "${el.text}": "",
        "${getCurrentScope().label}": "",
        "${item.entityName}": "",
        "${item.text}": "",
        "${props.inputPlaceholder}": "",
        "1 godzina": "",
        "10 minut": "",
        "12 godzin": "",
        "15 minut": "",
        "24 godziny": "",
        "3 godziny": "",
        "30 minut": "",
        "5 minut": "",
        "6 godzin": "",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "",
        "Adaptive sampling": "",
        "Administracja": "",
        "Administracja - Kraje": "",
        "Administracja - Miasta": "",
        "Administracja - Role": "",
        "Administracja - Stanowiska pracy": "",
        "Administracja - Użytkownicy": "",
        "Administracja - Województwa": "",
        "Administracja - Zespoły": "",
        "Administratorzy": "",
        "Adres domenowy": "",
        "Adres e-mail potwierdzony": "",
        "Adres email": "",
        "Adres email nadawcy": "",
        "Adres IP": "",
        "Adres IP: %0": "",
        "Adresy należy oddzielać przecinkami i muszą zaczynać się od http(s).": "",
        "Akcja": "",
        "Akcje": "",
        "Aktualizacja danych exif": "",
        "Aktualizuj": "",
        "Aktualna sesja": "",
        "Aktualne hasło": "",
        "Aktualne urządzenie": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywne sesje": "",
        "Aktywni": "",
        "Aktywny": "",
        "Angielski": "",
        "Anonimizuj": "",
        "Anuluj": "",
        "Aplikacja monitorująca": "",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "",
        "Aranżacja": "",
        "Autor": "",
        "Autoryzacja wymagana": "",
        "Azure AD": "",
        "Azure Application Insights": "",
        "Basic Auth": "",
        "Baza danych": "",
        "Bezpieczeństwo": "",
        "Bezpieczne połączenie SSL": "",
        "Blokada konta": "",
        "Blokada konta do": "",
        "Blokowanie kont": "",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "",
        "Błędne": "",
        "Błędy": "",
        "Bool": "",
        "brak": "",
        "Brak danych": "",
        "Brak elementów": "",
        "Brak kluczy": "",
        "Brak opcji": "",
        "Brak podanych adresów oznacza, że nie będą monitorowane żadne żądania HTTP.": "",
        "Brak wersji": "",
        "Brak wyboru": "",
        "Brak wyników": "",
        "Brak zdefiniowanych ról.": "",
        "Client ID": "",
        "Client Secret": "",
        "Co 10 dni": "",
        "Co 10 minut": "",
        "Co 12 godzin": "",
        "Co 15 minut": "",
        "Co 2 godziny": "",
        "Co 2 minuty": "",
        "Co 2 tygodnie": "",
        "Co 20 minut": "",
        "Co 3 godziny": "",
        "co 3 miesiące": "",
        "Co 3 miesiące": "",
        "co 30 dni": "",
        "Co 30 minut": "",
        "Co 4 miesiące": "",
        "Co 5 dni": "",
        "Co 5 minut": "",
        "Co 6 godzin": "",
        "co 6 miesięcy": "",
        "Co drugi dzień": "",
        "Co drugi miesiąc": "",
        "Co godzinę": "",
        "Co miesiąc": "",
        "Co minutę": "",
        "Co pół roku": "",
        "co rok": "",
        "Co tydzień": "",
        "Codziennie": "",
        "Connection String": "",
        "Cron": "",
        "Czas": "",
        "Czas nieaktywności użytkownika po którym zostanie wylogowany z panelu administracyjnego [min": "",
        "Czas trwania blokady": "",
        "Czas uruchomienia": "",
        "Czy aby na pewno chesz zrestartować aplikacje?": "",
        "Czy na pewno chcesz usunąć widget?": "",
        "Dalej": "",
        "Dane exif": "",
        "Dashboard aktywny": "",
        "Dashboard domyślny": "",
        "Dashboard został dodany.": "",
        "Dashboard został skopiowany.": "",
        "Dashboard został usunięty.": "",
        "Dashboard został zaktualizowane.": "",
        "Dashboardy": "",
        "Data do": "",
        "Data dodania": "",
        "Data modyfikacji": "",
        "Data od": "",
        "Data rejestracji": "",
        "Data uruchomienia": "",
        "Data uruchomienia (UTC)": "",
        "Data usunięcia": "",
        "Data utworzenia": "",
        "Data utworzenia wersji": "",
        "Data wygaśnięcia": "",
        "Data wylogowania": "",
        "Data zalogowania": "",
        "Data zdarzenia": "",
        "DateTime": "",
        "Długość historii haseł": "",
        "Dni": "",
        "Do akceptacji": "",
        "do czasu ręcznego odblokowania": "",
        "Dodaj": "",
        "Dodaj dashboard": "",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "",
        "Dodaj nowy folder": "",
        "Dodaj pliki": "",
        "Dodaj rolę": "",
        "Dodaj shortcode": "",
        "Dodaj użytkownika": "",
        "Dodaj widget": "",
        "dodał": "",
        "Dodanie": "",
        "Dodanie dashboardu": "",
        "Dodanie roli": "",
        "Dodanie użytkownika": "",
        "dodany": "",
        "Dodanych plików %0 (limit wynosi %1).": "",
        "Dokument PDF": "",
        "Dokument tekstowy": "",
        "Dołącz stack trace": "",
        "Domyślna": "",
        "Domyślne": "",
        "Domyślne filtry": "",
        "Domyślny": "",
        "Domyślny poziom logowania": "",
        "Dostęp niezdefiniowany": "",
        "Dostęp przyznany": "",
        "Dostęp zabroniony": "",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
        "Double": "",
        "Dozwolone rozszerzenia: %0.": "",
        "Dozwolone typy plików: %0.": "",
        "Dsn": "",
        "Duży układ siatki": "",
        "Działania masowe": "",
        "E-mail": "",
        "Edycja aranżacji dashboardu": "",
        "Edycja dashboardu": "",
        "Edycja logów": "",
        "Edycja roli": "",
        "Edycja użytkownika": "",
        "Edytowana wersja": "",
        "Edytuj": "",
        "Edytuj filtr": "",
        "Edytuj uprawnienia": "",
        "Eksport": "",
        "Element został przywrócony.": "",
        "Element został usunięty.": "",
        "Elementy zostały usunięte.": "",
        "Email potwierdzony": "",
        "False": "",
        "Filtr domyślny": "",
        "Filtr prywatny": "",
        "Filtr został usunięty": "",
        "Filtr został zapisany": "",
        "Filtry": "",
        "Folder główny": "",
        "Folder plików": "",
        "Foldery": "",
        "Godziny": "",
        "Grafana Cloud": "",
        "Grupa": "",
        "Harmonogram zadań": "",
        "Harmonogram został zmieniony": "",
        "Hasło": "",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "",
        "Hasło zostało zmienione. Zaloguj się ponownie": "",
        "Historia logowania": "",
        "Historia zadania": "",
        "Host": "",
        "i": "",
        "Id": "",
        "ID": "",
        "ID lub typ zadania": "",
        "Id modelu: %0": "",
        "Id obiektu": "",
        "Id sesji": "",
        "ID zadania": "",
        "Id zdarzenia": "",
        "Identyfikator zadania": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Import": "",
        "Import użytkowników": "",
        "Inspekcja": "",
        "Instalacja": "",
        "Int": "",
        "Kalendarz - Kategorie zasobów": "",
        "Katalog został utworzony": "",
        "Klucz prywatny": "",
        "Klucz publiczny": "",
        "Klucze są nie prawidłowe.": "",
        "Klucze są prawidłowe.": "",
        "Kod C#": "",
        "Kod CSS": "",
        "Kod HTML": "",
        "Kod JavaScript": "",
        "Kod TypeScript": "",
        "Kod Vue (Single-File Component)": "",
        "Kod wertfikacyjny": "",
        "Kod weryfikacyjny jest nieprawidłowy.": "",
        "Kolejka": "",
        "Kolor tła": "",
        "Komponent React": "",
        "Komunikat": "",
        "Konfiguracja harmonogramu (czas UTC)": "",
        "Konfiguracja została zmieniona.": "",
        "Konsola aplikacji": "",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "",
        "Konta użytkowników zostały odblokowane": "",
        "Konta użytkowników zostały usunięte z systemu": "",
        "Konta użytkowników zostały zablokowane": "",
        "Kontakt": "",
        "Kontakty - Typ działania": "",
        "Konto aktywne": "",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
        "Konto z dostępem do panelu": "",
        "Konto zanonimizowane": "",
        "Konwertuj obrazy do formatu WebP": "",
        "Kopiuj": "",
        "Kopiuj pole": "",
        "Kosz": "",
        "Lewy panel": "",
        "Licencja": "",
        "linie": "",
        "Lista dozwolonych / wykluczonych żądań HTTP": "",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "",
        "Lista jest pusta": "",
        "Lista zaufanych adresów IP": "",
        "Logi wydajnościowe": "",
        "Logowanie": "",
        "Logowanie zakończyło się niepowodzeniem.": "",
        "Logowanie zależności / żądań typu HTTP": "",
        "Logowanie zdarzeń": "",
        "Loguj wybrane": "",
        "Long": "",
        "Ładowanie elementów...": "",
        "Maksymalna rozdzielość obrazu po optymalizacji: %0x%1px": "",
        "Maksymalny rozmiar pliku: %0MB.": "",
        "Mały układ siatki": "",
        "Metoda autentykacji": "",
        "Microsoft Aspire": "",
        "Miesiące": "",
        "Minimalna długość hasła": "",
        "Minuty": "",
        "Modyfikacja": "",
        "Moje filtry": "",
        "Moje pliki": "",
        "Monitor kolejek": "",
        "Monitoring": "",
        "Monitoring aplikacji": "",
        "Monitorowane adresy URL dla żądań HTTP": "",
        "Monitoruj bazy danych (SQL, Redis, ElasticSearch)": "",
        "Monitoruj statystyki .NET": "",
        "Monitoruj żądania HTTP": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość zmiany hasła jest zablokowana. Obsługa hasła znajduje się po stronie zewnętrznej bazy danych %0.": "",
        "Mój tytuł": "",
        "Na pewno usunąć": "",
        "Nagłówki HTTP": "",
        "Najpierwsz zapisz wprowadzone zmiany": "",
        "Name": "",
        "Następna strona": "",
        "Nazwa": "",
        "Nazwa dashboardu": "",
        "Nazwa filtra": "",
        "Nazwa katalogu": "",
        "Nazwa nadawcy": "",
        "Nazwa pliku": "",
        "Nazwa pliku została zmieniona.": "",
        "Nazwa pola": "",
        "Nazwa roli": "",
        "Nazwa typu": "",
        "Nazwa urządzenia": "",
        "Nazwa usługi": "",
        "Nazwa użytkownika": "",
        "Nazwa zadania": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie loguj wybranych": "",
        "Nie masz uprawnień do panelu administracyjnego.": "",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "",
        "Nie możesz modyfikować uprawnień": "",
        "Nie można dodać pliku \"%0\" z powodu: %1.": "",
        "Nie można usunąć swojego konta.": "",
        "Nie udało się pobrać konfiguracji dashboardu": "",
        "Nie udało się pobrać listy filtrów": "",
        "Nie udało się pobrać listy kolejek": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy typów modeli": "",
        "Nie udało się pobrać widgetu/ów": "",
        "Nie udało się usunąć szablonu": "",
        "Nie udało się wysłać pliku": "",
        "Nie udało się załadować elementów": "",
        "Nie udało się zapisać filtra": "",
        "Nie udało się zapisać ustawień dashboardu": "",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
        "Nie wybrano żadnego użytkownika.": "",
        "nie wymuszaj zmiany hasła": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie znaleziono filtrów.": "",
        "Nie znaleziono kolumn.": "",
        "Nie znaleziono pasujących elementów.": "",
        "Nie znaleziono właściwego widgetu": "",
        "Nie znaleziono żadnego pola.": "",
        "Nie znaleziono żadnych elementów": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nieaktywni": "",
        "niedozwolone rozszerzenie pliku (%0)": "",
        "niedozwolony typ pliku (%0)": "",
        "Niepotwierdzeni": "",
        "Nieprawidłowy adres email": "",
        "Nieprawidłowy adres URL": "",
        "Nieprzeczytane": "",
        "Nieudane logowania": "",
        "Nieznany typ pliku": "",
        "Nikomu nie przydzielono uprawnień": "",
        "Nowe hasło": "",
        "Numer sesji": "",
        "Numer telefonu": "",
        "OAuth2 dla Exchange Online": "",
        "Obiekt %0 został %1": "",
        "Obiekt JSON": "",
        "Obraz został wycięty.": "",
        "Oczekujące": "",
        "Oczekuje na wysłanie": "",
        "Odblokuj": "",
        "Odrzucone": "",
        "Odśwież": "",
        "Odznacz": "",
        "Ok": "",
        "OpenTelemetry": "",
        "Opis": "",
        "Opisy": "",
        "Opróżnij kategorię": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Oraz hasło": "",
        "Oraz nowe hasło": "",
        "Ostatnia aktywność": "",
        "Ostatnia strona": "",
        "Ostrzeżenia": "",
        "Otwórz": "",
        "Pierwsza strona": "",
        "Plik audio": "",
        "Plik binarny": "",
        "Plik CSS": "",
        "Plik CSV": "",
        "Plik DOC": "",
        "Plik DOCX": "",
        "Plik GIF": "",
        "Plik HTML": "",
        "Plik jest wysyłany": "",
        "Plik JPEG": "",
        "Plik JPG": "",
        "Plik MP4": "",
        "Plik PNG": "",
        "Plik skompresowany": "",
        "Plik z logami": "",
        "Plik ZIP": "",
        "Plik został wysłany": "",
        "Pliki": "",
        "Pliki do wysłania: %0": "",
        "Pliki współdzielone": "",
        "po %0 nieudanych próbach logowania": "",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Pobierz": "",
        "Poczta wychodząca": "",
        "Podaj kod weryfikacyjny": "",
        "Podaj swój adres email": "",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "",
        "Podczas przesyłania plików wystąpił nieznany błąd": "",
        "Podgląd": "",
        "Podziedziałek - Piątek": "",
        "Pokaż historię": "",
        "Pokaż szczegóły": "",
        "Pokaż więcej": "",
        "pokaż więcej...": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole \"Nazwa\" jest wymagane.": "",
        "Pole \"Szerokość\" jest wymagane.": "",
        "Pole \"Wysokość\" jest wymagane.": "",
        "Pole jest wymagane": "",
        "Pole nie może zawierać spacji": "",
        "Pole skopiowane": "",
        "Polityka prywatności": "",
        "Polski": "",
        "Poprzednia strona": "",
        "Porównaj %0": "",
        "Porównaj z edytowaną wersją": "",
        "Porównywana wersja": "",
        "Port": "",
        "Potwierdzenia": "",
        "Potwierdzenie kopiowania": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie wylogowania użytkownika": "",
        "Potwierdzenie zmiany statusu": "",
        "Potwierdź": "",
        "Powiadomienia": "",
        "Powrót": "",
        "Powtórz hasło": "",
        "Powtórzone": "",
        "Pozostałe": "",
        "Pozostało %0 znaków.": "",
        "Prawy panel": "",
        "Profil użytkownika": "",
        "Profil został zaktualizowany.": "",
        "Próbkowanie": "",
        "Prywatny": "",
        "Przeczytane": "",
        "Przefiltrowani użytkownicy": "",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "",
        "Przeniesienie wybranych elementów": "",
        "przeniesiony do kosza": "",
        "Przenieś": "",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "przeniósł do kosza": "",
        "Przestrzeń nazw": "",
        "Przesyłanie plików powiodło się.": "",
        "Przetestuj poprawność zapisanych kluczy": "",
        "Przetestuj ustawienia poczty": "",
        "Przetwarzane": "",
        "Przypisanie ról": "",
        "Przywrócenie": "",
        "przywrócił z kosza": "",
        "przywrócony z kosza": "",
        "Przywróć": "",
        "Przywróć filtr": "",
        "Przyznaj dostęp": "",
        "Publiczny": "",
        "Ranga": "",
        "ReCaptcha": "",
        "Rejestr zmian": "",
        "Repozytorium plików": "",
        "Resetuj": "",
        "Rola": "",
        "Rola aktywna": "",
        "Rola domyślna": "",
        "Rola została dodana.": "",
        "Rola została usunięta.": "",
        "Rola została zaktualizowana.": "",
        "Role i uprawnienia": "",
        "Role użytkownika": "",
        "Role zostały przypisane": "",
        "Rozmiar": "",
        "Rozmiar pliku": "",
        "Rozmiar zdjęcia został zmieniony.": "",
        "Sentry": "",
        "Sesja": "",
        "Sesja nr %0": "",
        "Sesja użytkownika": "",
        "Skrypt SQL": "",
        "słowa": "",
        "Start": "",
        "Status": "",
        "String": "",
        "Strona główna": "",
        "Synchronizacja użytkowników": "",
        "System": "",
        "Szczegóły": "",
        "Szczegóły zadania": "",
        "Szczegóły zdarzenia": "",
        "Szczegóły zdarzenia nr %0": "",
        "Szerokość": "",
        "Szkic": "",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "",
        "Tagi": "",
        "Tak": "",
        "Tekst alternatywny": "",
        "Ten dashboard nie zawiera żadnych widgetów": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Tenant ID": "",
        "Teraz": "",
        "Testowy adres email": "",
        "To pole jest wymagane": "",
        "Tracing": "",
        "True": "",
        "Twoje hasło wygasło. Zmień je na nowe.": "",
        "Tydzień": "",
        "Tylko moje": "",
        "Typ": "",
        "Typ konta": "",
        "Typ mime": "",
        "Typ obiektu": "",
        "Typ pliku": "",
        "Typ właściwy": "",
        "typu \"%0\" o ID \"%1\"": "",
        "Układ listy": "",
        "Uprawnienia": "",
        "Uri": "",
        "Uruchom zadanie": "",
        "Urządzenie zostało usunięte.": "",
        "Ustaw domyślny poziom logowania. Logi poniżej tego poziomu nie bądą zbierane niezależnie od pozostałych ustawień.": "",
        "Ustaw poziomy logów które będą wysyłane do poszczególnych rejestrów.": "",
        "Ustaw poziomy logów które będą zbierane z poszczególnych przestrzeni nazw.": "",
        "Ustawienia": "",
        "Ustawienia konta": "",
        "Ustawienia widgetów zostały zapisane": "",
        "Ustawienia widgetu": "",
        "Ustawienia zostały zapisane.": "",
        "usunął": "",
        "Usunął": "",
        "Usunięcie": "",
        "usunięty": "",
        "Usuń": "",
        "Usuń filtr": "",
        "Usuń kolor": "",
        "Usuń plik": "",
        "Usuń plik z listy": "",
        "Usuń urządzenie": "",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "Usuwanie użytkowników": "",
        "Utworzył": "",
        "Utwórz katalog": "",
        "Utwórz nowy": "",
        "Użytkownicy": "",
        "Użytkownicy w tej roli": "",
        "Użytkownik": "",
        "Użytkownik \"%0\" %1 obiekt %2": "",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został wylogowany.": "",
        "Użytkownik został zaktualizowany.": "",
        "Użytkownik został zanonimizowany.": "",
        "W każdy dzień tygodnia": "",
        "Walidacja certyfikatu SSL": "",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "",
        "Wartość musi być liczbą całkowitą": "",
        "Wartość musi być liczbą dodatnią": "",
        "Wartość musi być liczbą ujemną": "",
        "Warunki korzystania z usług Google": "",
        "Ważne informacje": "",
        "Wczytywanie danych...": "",
        "Weekend": "",
        "Wersja utowrzona przez": "",
        "Wersje dokumentu": "",
        "Wiadomość testowa została wysłana.": "",
        "Więcej": "",
        "więcej...": "",
        "Właściwości": "",
        "Włączone": "",
        "Włączony": "",
        "Wpisz adresy po przecinku.": "",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "",
        "Wprowadzona wartość jest nieprawidłowa": "",
        "Wprowadzona wartość jest za długa": "",
        "Wprowadzona wartość jest za krótka": "",
        "Wprowadzona wartość jest za niska": "",
        "Wprowadzona wartość jest za wysoka": "",
        "Wprowadzona wartość nie jest poprawna": "",
        "Wróć do logowania": "",
        "Wróć do strony głównej": "",
        "Wstaw cztery kolumny 1/4": "",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "",
        "Wstaw dwie równe kolumny": "",
        "Wstaw szablon informacyjny ze zdjęciem": "",
        "Wstaw trzy kolumny 1/3": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "",
        "Wybierz": "",
        "wybierz długość": "",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "",
        "Wybierz plik": "",
        "Wybierz pliki": "",
        "Wybierz pliki (do {0})": "",
        "Wybierz shortcode": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wybierz zaznaczone": "",
        "wybierz...": "",
        "Wybór języka": "",
        "Wybrane": "",
        "Wybrane elementy zostały przeniesione.": "",
        "Wybrane elementy zostały usunięte.": "",
        "wybrane elementy?": "",
        "Wybrane pliki": "",
        "Wybrane pliki: {0}": "",
        "Wybrane: %0": "",
        "wybranego elementu": "",
        "Wybrano %0 użytkowników.": "",
        "Wybrano jednego użytkownika.": "",
        "Wybrany element został usunięty.": "",
        "wybrany element?": "",
        "wybranych elementów": "",
        "Wyklucz logowanie zależności": "",
        "Wykonaj": "",
        "Wyloguj się": "",
        "Wyloguj zalogowanego obecnie użytkownika": "",
        "Wyłaczone": "",
        "Wyłączone wysyłanie powiadomień": "",
        "Wymagaj znaków specjalnych w hasłach": "",
        "Wymagane jest ustawienie minimalnej długości hasła": "",
        "Wymiary": "",
        "Wymuś zmianę hasła": "",
        "Wysłane": "",
        "Wysokość": "",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpiły błędy podczas zapisywania formularza": "",
        "Wysyłaj dane o użytkowniku": "",
        "Wyszukaj (Ctrl+Q)": "",
        "Wyszukaj widget": "",
        "Wyszukaj...": "",
        "Wyślij": "",
        "Wyślij kod": "",
        "Wyświetlam": "",
        "Wytnij": "",
        "Zaakceptowany": "",
        "Zabierz dostęp": "",
        "Zablokuj": "",
        "Zachowaj oryginalny format obrazów": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "Zadanie zostało uruchomione.": "",
        "Zadanie zostało włączone": "",
        "Zadanie zostało wyłączone": "",
        "Zaimportowano listę użytkowników.": "",
        "Zakolejkowane": "",
        "Zakończ sesję": "",
        "Zakończ sesję aby wylogować użytkownika": "",
        "Zakończone": "",
        "Zaloguj się": "",
        "Zaloguj się na swoje konto": "",
        "Zamknij": "",
        "Zapamiętaj logowanie": "",
        "Zapamiętane urządzenia": "",
        "Zapisz": "",
        "Zapisz aranżację": "",
        "Zapisz filtr": "",
        "Zapisz i wróć": "",
        "Zapisz widget": "",
        "Zapisz zmiany": "",
        "Zaplanowane": "",
        "Zapomniałeś hasła?": "",
        "Zastępstwo": "",
        "Zaufane adresy IP": "",
        "Zaznacz": "",
        "Zaznacz wszystkie": "",
        "Zbieranie i przechowywanie logów": "",
        "Zdarzenie": "",
        "Zdjęcie użytkownika": "",
        "Zespół": "",
        "Zmiana hasła": "",
        "Zmiana rozmiaru obrazu": "",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "",
        "Zmiany zostały zapisane.": "",
        "Zmień hasło": "",
        "Zmień nazwę": "",
        "Zmień nazwę katalogu": "",
        "Zmień nazwę pliku": "",
        "Zmień rozmiar": "",
        "Zmień status edytowanej wersji": "",
        "zmodyfikował": "",
        "Zmodyfikował": "",
        "zmodyfikowany": "",
        "znaki": "",
        "Zobacz przed opublikowaniem": "",
        "Zobacz sesję użytkownika": "",
        "Zobacz szczegóły sesji użytkownika": "",
        "Zobacz szczegóły zdarzenia": "",
        "Został przywrócony oryginalny harmonogram": "",
        "Zresetuj hasło": "",
        "Zrestartuj aplikacje": "",
        "Zwrócony": "",
        "Źródła logów": "",
        "Źródło": ""
    }
};
